import { Component } from '@angular/core';

@Component({
  selector: 'app-signature-callback',
  templateUrl: './signature-callback.component.html',
  styleUrls: ['./signature-callback.component.scss'],
})
export class SignatureCallbackComponent {}
